export enum StoreSetupSteps {
  CERTIFICATE = "certificate",
  PHONE_AND_STATE = "phone_and_state",
  COMPLETE = "complete",
}

export enum WholesaleStoreSetupSteps {
  CERTIFICATE = "certificate",
  COMPLETE = "complete",
}
